exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".actions-padding[data-v-24e9bb31]{padding-right:18px;padding-bottom:19px;padding-left:18px}.pt-switch[data-v-24e9bb31]{padding-top:20px}", "", {"version":3,"sources":["/vercel/path0/src/pages/Person.vue"],"names":[],"mappings":"AACA,kCACE,mBAAoB,AACpB,oBAAqB,AACrB,iBAAmB,CACpB,AACD,4BACE,gBAAkB,CACnB","file":"Person.vue","sourcesContent":["\n.actions-padding[data-v-24e9bb31] {\n  padding-right: 18px;\n  padding-bottom: 19px;\n  padding-left: 18px;\n}\n.pt-switch[data-v-24e9bb31] {\n  padding-top: 20px;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-24e9bb31","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Person.vue
// module id = 454
// module chunks = 8